import * as React from "react";
import { IconSort } from "../icons/IconSort";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";
import { useMprcTheme } from "../MprcThemeProvider";

export const IconButtonOrderBy: React.FC<MprcIconButtonProps> = ({ title, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonOrderBy.title;

    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconSort />
        </MprcIconButton>
    );
};
